import React from "react";

export function RegistrationId(props: { value: number | any }) {
  const index = props.value.length - 4;
  const formattedId =
    props.value.slice(0, index) + "-" + props.value.slice(index);
  return <div>{formattedId}</div>;
}
